import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Este libro es religioso?',
    a: 'No. Es espiritual pero no pertenece a ninguna religión específica. Los rituales están diseñados para personas de cualquier creencia.'
  }, {
    q: '¿Necesito experiencia previa en rituales?',
    a: 'No. El libro está diseñado para principiantes. Todo está explicado paso a paso.'
  }, {
    q: '¿Cómo recibo el ebook?',
    a: 'Recibirás acceso inmediato después del pago. Podrás leerlo desde tu celular, tablet o computador.'
  }, {
    q: '¿Puedo usar estos rituales para otras personas?',
    a: 'Sí. También aprenderás cómo crear ceremonias para otras personas.'
  }, {
    q: '¿Cuántas páginas tiene el libro?',
    a: 'Más de 200 páginas de contenido profundo y práctico.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream-light py-20 md:py-32" data-id="element-83">
      <div className="max-w-3xl mx-auto px-6" data-id="element-84">
        <div className="text-center mb-12" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark" data-id="element-86">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-87">
          {faqs.map((faq, idx) => <div key={idx} className="border border-gold-main/20 rounded-sm bg-white overflow-hidden" data-id="element-88">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === idx} data-id="element-89">
                <span className="font-playfair font-semibold text-lg text-brown-dark pr-4" data-id="element-90">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold-main transition-transform duration-300 flex-shrink-0 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-91" />
              </button>

              <AnimatePresence data-id="element-92">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-93">
                    <div className="p-6 pt-0 font-lora text-brown-light border-t border-gold-main/10" data-id="element-94">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}